import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Tooltip, Input, Button, Select,Modal } from "antd";
import Pagination from "../Component/Pagination";
import { HiOutlineRefresh } from "react-icons/hi";
import { CSVLink } from 'react-csv';
import { toast } from "react-toastify";


const { Option } = Select;

const AllTrades = () => {
  const [totalPages, setTotalPages] = useState(0);
  const [searchUsernames, setSearchUsernames] = useState("");
  const [statusFilter, setStatusFilter] = useState("ALL");
  const [Reason, setReason] = useState("All");

  const [filter, setFilter] = useState("LIVE");
  const [filter1, setFilter1] = useState("FUTURES");
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(100);
  const [data, setData] = useState([]);

  const onPageChange = (page) => {
    setPage(page);
  };

  const handlePageSizeChange = (size) => {
    setSize(size);
  };

  // new api of current Price

  const [prices, setPrices] = useState({ spot: {}, futures: {} });

  const fetchPrices = async () => {
    try {
      const symbols = [
        "ETHUSDT",
        "BNBUSDT",
        "XRPUSDT",
        "MANAUSDT",
        "SOLUSDT",
        "DOGEUSDT",
        "BNBUSDC",
        "SOLUSDC",
        "DOGEUSDC",
        "XRPUSDC",
      "ETHUSDC",
      "SUIUSDT",
      "TRXUSDT",
      "OPUSDT",
      "ADAUSDT",
      "LINKUSDT"

      ];

      // Fetch Spot Prices
      const spotResponse = await axios.get(
        "https://api.binance.com/api/v3/ticker/price",
        {
          params: { symbols: JSON.stringify(symbols) },
        }
      );

      const spotPrices = spotResponse.data.reduce(
        (acc, item) => ({
          ...acc,
          [item.symbol]: item.price,
        }),
        {}
      );

      // Fetch Futures Prices
      const futurePromises = symbols.map((symbol) =>
        axios.get("https://fapi.binance.com/fapi/v1/ticker/price", {
          params: { symbol },
        })
      );

      const futureResponses = await Promise.all(futurePromises);

      const futurePrices = futureResponses.reduce(
        (acc, response) => ({
          ...acc,
          [response.data.symbol]: response.data.price,
        }),
        {}
      );

      setPrices({ spot: spotPrices, futures: futurePrices });
    } catch (error) {
      console.error("Error fetching prices:", error);
    }
  };

  useEffect(() => {
    fetchPrices();
  }, [data]);

  //   useEffect(() => {
  //     fetchPrices();
  //     // const interval = setInterval(fetchPrices, 10000); // Refresh every 10 seconds
  //     // return () => clearInterval(interval); // Clean up on component unmount
  //   }, []);

  // new api of Current Price

  const ViewAPIs = (size, page, tradeType, exchangetype, usernames, status) => {
    const jwt = localStorage.getItem("jwt");

    const postData = {
      jwt: jwt,
      page_no: page,
      page_size: size,


    };

    if (tradeType !== "ALL") {
      postData.api_type = [tradeType];
    }

    if (usernames) {
      postData.username = usernames.split(",").map((name) => name.trim());
    }

    if (exchangetype !== "ALL") {
      postData.exchange_type = [exchangetype];
    } else {
      postData.exchange_type = ["SPOT", "FUTURE"];
    }

    if (status && status !== "ALL") {
      postData.status = [status]; // Add the selected status to the API request
    }

    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      url: process.env.REACT_APP_API + "/bot/view_bots",
      data: postData,
    })
      .then((res) => {
        if (res?.data?.Success === "No transactions yet!") {
          setData([]);
          // message.info("No transactions yet!");
        } else {
          setData(res?.data?.Success);
          // props.formSubmitted(data)
        }
      })
      .catch((err) => {
        // message.error(err);
      });
  };
  //

  const ViewTotalApis = (
    size,
    page,
    tradeType,
    exchangetype,
    usernames,
    status
  ) => {
    const jwt = localStorage.getItem("jwt");

    const postData = {
      jwt: jwt,
      page_no: page,
      page_size: size,
    };

    if (tradeType !== "ALL") {
      postData.api_type = [tradeType];
    }

    if (usernames) {
      postData.username = usernames.split(",").map((name) => name.trim());
    }

    if (exchangetype !== "ALL") {
      postData.exchange_type = [exchangetype];
    } else {
      postData.exchange_type = ["SPOT", "FUTURE"];
    }

    if (status && status !== "ALL") {
      postData.status = [status]; // Add the selected status to the API request
    }

    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      url: process.env.REACT_APP_API + "/bot/total_page_view_bots",
      data: postData,
    })
      .then((res) => {
        setTotalPages(res?.data?.Success);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //
  useEffect(() => {
    ViewTotalApis(size, page, filter, filter1, searchUsernames, statusFilter);
    ViewAPIs(size, page, filter, filter1, searchUsernames, statusFilter);
  }, [page, size, filter, filter1, statusFilter]);

  const getValueForExchangeType = (exchangeType, values) => {
    if (exchangeType === "FUTURES") {
      return values.reduce((acc, val) => acc + (val || 0), 0);
    }
    return values || "--";
  };

  const dataSource = data.map((item) => {
    let openposition = 0;
    let balanceview = 0;

    if (item.Exchange_Type === "FUTURES") {
      const openpositionl =
        (item.AvgBuyPriceL * item.TotalQuantityL) / item.Leverage +
        item.TotalQuantityL * (prices.futures[item.Symbol] - item.AvgBuyPriceL);
      const openpositions =
        (item.AvgBuyPriceS * item.TotalQuantityS) / item.Leverage +
        (item.AvgBuyPriceS - prices.futures[item.Symbol]) * item.TotalQuantityS;

      openposition = openpositionl + openpositions;
      balanceview = item.BalanceL + item.BalanceS;
    } else {
      openposition = item.TotalQuantity * prices.spot[item.Symbol];
      balanceview = item.Balance;
    }

    const Invest = item.Invest ? item.Invest : item.InvestL + item.InvestS;
    const CurrentAssetValue = openposition; // Total current asset value

    const CurrentDraw = (
      ((CurrentAssetValue + balanceview) * 100) / Invest -
      100
    ).toFixed(4);



    return {
      Bot_ID: item?.Bot_ID || "--",
      Username: item?.Username || "--",
      APIID: item?.APIID || "--",
      API_Name: item?.API_Name || "--",
      Key: item?.Key || "--",
      Project: item?.Project || "--",
      Secret: item?.Secret || "--",
      Passphrase: item?.Passphrase || "--",
      Exchange_Type: item?.Exchange_Type || "--",
      Exchange: item?.Exchange || "--",
      Type: item?.Type || "--",
      Reason: item?.Reason || "--",
      CopyTradeID: item?.CopyTradeID || "--",
      VarBotID: item?.VarBotID || "--",
      BotName: item?.BotName || "--",
      Symbol: item?.Symbol || "--",
      InvestF: item?.InvestL + item?.InvestS,
      Invest: item?.Invest,
Comment:item?.Comment,
      VolumeMultiplierL: item?.VolumeMultiplierL,
      VolumeMultiplierS: item?.VolumeMultiplierS,
      VolumeMultiplier: item?.VolumeMultiplier,
      Investment_Risk: item?.Investment_Risk,
      LossPercent: item?.LossPercent,
      LossPercentL: item?.LossPercentL,
      LossPercentS: item?.LossPercentS,
      TakeProfitPercent: item?.TakeProfitPercent,
      TakeProfitPercentL: item?.TakeProfitPercentL,
      TakeProfitPercentS: item?.TakeProfitPercentS,
      LossMultiplier: item?.LossMultiplier,
      LossMultiplierL: item?.LossMultiplierL,
      LossMultiplierS: item?.LossMultiplierS,
      OrderCount: item?.OrderCount,
      OrderCountL: item?.OrderCountL,
      OrderCountS: item?.OrderCountS,
      CurrentOrderCount: item?.CurrentOrderCount,
      CurrentOrderCountL: item?.CurrentOrderCountL,
      CurrentOrderCountS: item?.CurrentOrderCountS,
      CurrentVolumeMultiplier: item?.CurrentVolumeMultiplier,
      CurrentVolumeMultiplierL: item?.CurrentVolumeMultiplierL,
      CurrentVolumeMultiplierS: item?.CurrentVolumeMultiplierS,
      CurrentLossMultiplier: item?.CurrentLossMultiplier,
      CurrentLossMultiplierL: item?.CurrentLossMultiplierL,
      CurrentLossMultiplierS: item?.CurrentLossMultiplierS,
      BaseOrderVolumeL: item?.BaseOrderVolumeL?.toFixed(4),
      BaseOrderVolumeS: item?.BaseOrderVolumeS?.toFixed(4),
      BaseOrderVolume: item?.BaseOrderVolume?.toFixed(4),
      Hold: item?.Hold,
      HoldL: item?.HoldL,
      HoldS: item?.HoldS,
      BaseOrderValue: getValueForExchangeType(item?.Exchange_Type, [
        item?.BaseOrderVolumeL,
        item?.BaseOrderVolumeS,
        item?.BaseOrderVolume,
      ]),
      BalanceValue: getValueForExchangeType(item?.Exchange_Type, [
        item?.BalanceL,
        item?.BalanceS,
        item?.Balance,
      ]),
      Current_Session: item?.Current_Session || "--",
      Current_SessionL: item?.Current_SessionL || "--",
      Current_SessionS: item?.Current_SessionS || "--",
      OrderTypeOpen: item?.OrderTypeOpen || "--",
      OrderTypeClose: item?.OrderTypeClose || "--",
      Drawdown: item?.Drawdown || "--",
      Take_Profit: item?.Take_Profit || "--",
      Status: item?.Status || "--",
      Total_Investment: item?.Total_Investment || "--",
      Initial_Balance: item?.Initial_Balance || "--",
      TotalQuantity: item?.TotalQuantity || "--",
      AvgBuyPrice: item?.AvgBuyPrice || "--",
      Brokerage: item?.Brokerage || "--",
      TotalBrokerage: item?.TotalBrokerage || "--",
      BuyPrice: item?.BuyPrice || "--",
      SellPrice: item?.SellPrice || "--",
      HoldingPeriod: item?.HoldingPeriod || "--",
      Created_At: item?.Created_At,
      ExpectedBaseOrderVolumeL: item?.ExpectedBaseOrderVolumeL || "--",
      ExpectedBaseOrderVolumeS: item?.ExpectedBaseOrderVolumeS || "--",
      ExpectedBaseOrderVolume: item?.ExpectedBaseOrderVolume || "--",

      BalanceF: (item?.BalanceL + item?.BalanceS)?.toFixed(4),
      Balance: item?.Balance?.toFixed(4),
      Leverage: item?.Leverage || "--",
      TotalQuantityF: (item?.TotalQuantityL + item?.TotalQuantityS)?.toFixed(4),

      TotalQuantity: item?.TotalQuantity?.toFixed(4),
      SpotPrice: prices.spot[item.Symbol] || "--",
      FuturesPrice: prices.futures[item.Symbol] || "--",

      // Current Asset Calculation
      CurrentAsset: (
        (parseFloat(item?.TotalQuantityL || 0) +
          parseFloat(item?.TotalQuantityS || 0)) *
        parseFloat(prices.futures[item.Symbol] || 0) +
        parseFloat(item?.TotalQuantity || 0) *
        parseFloat(prices.spot[item.Symbol] || 0)
      ).toFixed(2),

      // Add CurrentDraw here
      CurrentDraw: CurrentDraw,
    };
  });

  const prepareDataForCSV = () => {
    const csvData = Array.isArray(data)
      ? data?.map((item, index) => {
        let openposition = 0;
        let balanceview = 0;

        if (item.Exchange_Type === "FUTURES") {
          const openpositionl =
            (item.AvgBuyPriceL * item.TotalQuantityL) / item.Leverage +
            item.TotalQuantityL * (prices.futures[item.Symbol] - item.AvgBuyPriceL);
          const openpositions =
            (item.AvgBuyPriceS * item.TotalQuantityS) / item.Leverage +
            (item.AvgBuyPriceS - prices.futures[item.Symbol]) * item.TotalQuantityS;

          openposition = openpositionl + openpositions;
          balanceview = item.BalanceL + item.BalanceS;
        } else {
          openposition = item.TotalQuantity * prices.spot[item.Symbol];
          balanceview = item.Balance;
        }

        const Invest = item.Invest ? item.Invest : item.InvestL + item.InvestS;
        const CurrentAssetValue = openposition;

        return {
          Created_At: item?.Created_At || "--",
          Username: item?.Username || "--",
          Exchange: item?.Exchange || "--",
          Bot_ID: item?.Bot_ID || "--",
          API_Name: item?.API_Name || "--",
          BotName: item?.BotName || "--",
          Symbol: item?.Symbol || "--",
          Investment_Risk: item?.Investment_Risk,
          Invest: item?.Invest ? item?.Invest : item?.InvestL + item?.InvestS,
          Balance: item?.Balance?.toFixed(4)
            ? item?.Balance?.toFixed(4)
            : (item?.BalanceL + item?.BalanceS)?.toFixed(4),
          TotalQuantity: item?.TotalQuantity?.toFixed(4)
            ? item?.TotalQuantity?.toFixed(4)
            : (item?.TotalQuantityL + item?.TotalQuantityS)?.toFixed(4),

          MarketPrice: prices.spot[item.Symbol]
            ? parseFloat(prices.spot[item.Symbol] || "--")
            : prices.futures[item.Symbol]
              ? parseFloat(prices.futures[item.Symbol] || "--")
              : "--",

          // Calculate CurrentDraw
          CurrentDrawdown_TakeProfit: (
            ((CurrentAssetValue + balanceview) * 100) / Invest - 100
          ).toFixed(4),

          Drawdown_Take_Profit: `${item?.Drawdown || "--"} / ${item?.Take_Profit || "--"}`,
          Status: item?.Status || "--",
          Reason: item?.Reason || "--",

        };
      })
      : [];

    return csvData;
  };

  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});

  const handleChange = ( filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };


  const [commentModal, setCommentModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState("");
  const [comment, setComment] = useState("");
  const [mycopytradeid, setmycopytradeid] = useState()

  const handleComment = (record) => {
    setCommentModal(true);
    setSelectedUser(record.Username);
    setmycopytradeid(record.CopyTradeID)
  };

  const handleOk = () => {

    const jwt = localStorage.getItem("jwt");

    const postData = {
      jwt: jwt,
      username: selectedUser,
      copytradeid: mycopytradeid,
      comment: comment,
    };
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      url: process.env.REACT_APP_API + "/bot/get_comments",
      data: postData,
    })
      .then((res) => {
       toast.success(res.data.Success);
       setCommentModal(false);
       setComment("");

      })
      .catch((err) => {
        console.log(err);
        // toast.error(res.response.data.Error);
        setCommentModal(false);

      });
  };

  const handleCancel = () => {
    setCommentModal(false);
    setComment("");
  };


  const columns = [
    {
      title: "Datetime",
      dataIndex: "Created_At",
      key: "Created_At",
      className: "whitespace-nowrap",
      width: undefined
    },

    {
      title: "Username",
      dataIndex: "Username",
      key: "username",
      width: undefined,
      className: "whitespace-nowrap",
      ellipsis: true,
    },

    {
      title: "Exchange",
      dataIndex: "Exchange",
      key: "Exchange",
      className: "whitespace-nowrap ",
      width: undefined
    },
    {
      title: "Bot ID",
      dataIndex: "CopyTradeID",
      key: "CopyTradeID",
      className: "whitespace-nowrap ",
      width: undefined
    },
    {
      title: "API Name",
      dataIndex: "API_Name",
      key: "API_Name",
      className: "whitespace-nowrap ",
      width: undefined
    },
    {
      title: "Bot Name",
      dataIndex: "BotName",
      key: "BotName",
      className: "whitespace-nowrap ",
      filters: [
        { text: "BASIC", value: "BASIC" },
        { text: "INTER", value: "INTER" },
        { text: "ADVANCE", value: "ADVANCE" },
        { text: "ULTRA", value: "ULTRA" },
      ],
      // filteredValue: filteredInfo.BotName || null,
      // onFilter: (value, record) => record.BotName.includes(value),
      // sorter: (a, b) => a.BotName.localeCompare(b.BotName), // Optional sorter for alphabetical sorting
      ellipsis: true,
    },
    {
      title: "Symbol",
      dataIndex: "Symbol",
      key: "Symbol",
      className: "whitespace-nowrap ",
      filters: [
        { text: 'ETHUSDT', value: 'ETHUSDT' },
        { text: 'BNBUSDT', value: 'BNBUSDT' },
        { text: 'XRPUSDT', value: 'XRPUSDT' },
        { text: 'MANAUSDT', value: 'MANAUSDT' },
        { text: 'SOLUSDT', value: 'SOLUSDT' },
        { text: 'DOGEUSDT', value: 'DOGEUSDT' },
      ],
      // filteredValue: filteredInfo.Symbol || null,
      // onFilter: (value, record) => record.Symbol.includes(value),
      //   sorter: (a, b) => a.Symbol.localeCompare(b.Symbol), // Optional sorter for symbol alphabetically
      ellipsis: true,
    },
    {
      title: (
        <Tooltip title="Investment Risk">
          <div>Invest (R)</div>
        </Tooltip>
      ),
      dataIndex: "Investment_Risk",
      key: "Investment_Risk",
      className: "whitespace-nowrap ",
      filters: [
        { text: "LOW", value: "LOW" },
        { text: "MEDIUM", value: "MEDIUM" },
        { text: "HIGH", value: "HIGH" },
      ],
      filteredValue: filteredInfo.Investment_Risk || null,
      onFilter: (value, record) => record.Investment_Risk === value,
      ellipsis: true,
    },
    ...(filter1 === "FUTURES"
      ? [
        {
          title: (
            <Tooltip title="Invest">
              <div>Invest</div>
            </Tooltip>
          ),
          dataIndex: "InvestF",
          key: "InvestF",
          className: "whitespace-nowrap ",
          sorter: (a, b) => a.InvestF - b.InvestF,
          sortOrder: sortedInfo.columnKey === 'InvestF' ? sortedInfo.order : null,
          ellipsis: true,
        },
      ]
      : [
        {
          title: (
            <Tooltip title="Invest">
              <div>Invest</div>
            </Tooltip>
          ),
          dataIndex: "Invest",
          key: "Invest",
          className: "whitespace-nowrap ",
          sorter: (a, b) => a.Invest - b.Invest,
          sortOrder: sortedInfo.columnKey === 'Invest' ? sortedInfo.order : null,
          ellipsis: true,

        },
      ]),

    // ...(filter1 === "FUTURES"
    //   ? [
    //       {
    //         title: (
    //           <Tooltip title="Take Profit Percent Long">
    //             <div>TP L(%)</div>
    //           </Tooltip>
    //         ),
    //         dataIndex: "TakeProfitPercentL",
    //         key: "TakeProfitPercentL",
    //         className: "whitespace-nowrap ",
    //       },
    //       {
    //         title: (
    //           <Tooltip title="Take Profit Percent Short">
    //             <div>TP S(%)</div>
    //           </Tooltip>
    //         ),
    //         dataIndex: "TakeProfitPercentS",
    //         key: "TakeProfitPercentS",
    //         className: "whitespace-nowrap ",
    //       },
    //     ]
    //   : [
    //       {
    //         title: (
    //           <Tooltip title="Take Profit Percent">
    //             <div>TP (%)</div>
    //           </Tooltip>
    //         ),
    //         dataIndex: "TakeProfitPercent",
    //         key: "TakeProfitPercent",
    //         className: "whitespace-nowrap ",
    //       },
    //     ]),

    ...(filter1 === "FUTURES"
      ? [
        {
          title: (
            <Tooltip title="Balance">
              <div>Balance</div>
            </Tooltip>
          ),
          dataIndex: "BalanceF",
          key: "BalanceF",
          className: "whitespace-nowrap ",
          sorter: (a, b) => a.BalanceF - b.BalanceF, // Sort based on BalanceF values
          sortOrder: sortedInfo.columnKey === 'BalanceF' ? sortedInfo.order : null,
          ellipsis: true,
        },
      ]
      : [
        {
          title: (
            <Tooltip title="Balance">
              <div>Balance</div>
            </Tooltip>
          ),
          dataIndex: "Balance",
          key: "Balance",
          className: "whitespace-nowrap ",
          sorter: (a, b) => a.Balance - b.Balance, // Sort based on Balance values
          sortOrder: sortedInfo.columnKey === 'Balance' ? sortedInfo.order : null,
          ellipsis: true,
        },
      ]),

    ...(filter1 === "FUTURES"
      ? [
        {
          title: (
            <Tooltip title="Leverage">
              <div>Lev</div>
            </Tooltip>
          ),
          dataIndex: "Leverage",
          key: "Leverage",
          className: "whitespace-nowrap ",
        },
      ]
      : []),

    ...(filter1 === "FUTURES"
      ? [
        {
          title: (
            <Tooltip title="Current Quantity">
              <div>CQ</div>
            </Tooltip>
          ),
          dataIndex: "TotalQuantityF",
          key: "TotalQuantityF",
          className: "whitespace-nowrap ",
          sorter: (a, b) => a.TotalQuantityF - b.TotalQuantityF, // Sort based on TotalQuantityF values
          sortOrder: sortedInfo.columnKey === 'TotalQuantityF' ? sortedInfo.order : null,
          ellipsis: true,
        },
      ]
      : [
        {
          title: (
            <Tooltip title="Current Quantity">
              <div>CQ</div>
            </Tooltip>
          ),
          dataIndex: "TotalQuantity",
          key: "TotalQuantity",
          className: "whitespace-nowrap ",
          sorter: (a, b) => a.TotalQuantity - b.TotalQuantity, // Sort based on TotalQuantity values
          sortOrder: sortedInfo.columnKey === 'TotalQuantity' ? sortedInfo.order : null,
          ellipsis: true,
        },
      ]),

    ...(filter1 === "FUTURES"
      ? [
        {
          title: (
            <Tooltip title="Market Price">
              <div>MP</div>
            </Tooltip>
          ),
          dataIndex: "FuturesPrice",
          key: "FuturesPrice",
          className: "whitespace-nowrap ",
          sorter: (a, b) => a.FuturesPrice - b.FuturesPrice, // Sort based on FuturesPrice values
          sortOrder: sortedInfo.columnKey === 'FuturesPrice' ? sortedInfo.order : null,
          ellipsis: true,
        },
      ]
      : [
        {
          title: (
            <Tooltip title="Market Price">
              <div>MP</div>
            </Tooltip>
          ),
          dataIndex: "SpotPrice",
          key: "SpotPrice",
          className: "whitespace-nowrap ",
          sorter: (a, b) => a.SpotPrice - b.SpotPrice, // Sort based on SpotPrice values
          sortOrder: sortedInfo.columnKey === 'SpotPrice' ? sortedInfo.order : null,
          ellipsis: true,
        },
      ]),
    {
      title: (
        <Tooltip title="Current Asset">
          <div>CA</div>
        </Tooltip>
      ),
      dataIndex: "CurrentAsset",
      key: "CurrentAsset",
      className: "whitespace-nowrap ",
      sorter: (a, b) => a.CurrentAsset - b.CurrentAsset, // Sort based on CurrentAsset values
      sortOrder: sortedInfo.columnKey === 'CurrentAsset' ? sortedInfo.order : null,
      ellipsis: true,
    },

    {
      title: (
        <Tooltip title="Current Drawdown / Take Profit">
          <div>C[D/TP]</div>
        </Tooltip>
      ),
      dataIndex: "CurrentDraw",
      key: "CurrentDraw",
      className: "whitespace-nowrap ",
      sorter: (a, b) => a.CurrentDraw - b.CurrentDraw, // Sort based on CurrentDraw values
      sortOrder: sortedInfo.columnKey === 'CurrentDraw' ? sortedInfo.order : null,
      ellipsis: true,
    },

    {
      title: (
        <Tooltip title="Drawdown / Take Profit">
          <div>D/TP</div>
        </Tooltip>
      ),
      key: "Drawdown_TakeProfit",
      className: "whitespace-nowrap",
      render: (record) => (
        <div>
          {record.Drawdown} / {record.Take_Profit}
        </div>
      ),
    },

    {
      title: "Status",
      dataIndex: "Status",
      key: "Status",
      className: "whitespace-nowrap ",
      // filters: [
      //   { text: "ACTIVE", value: "ACTIVE" },
      //   { text: "INACTIVE", value: "INACTIVE" },
      //   { text: "PAUSED", value: "PAUSED" },
      //   { text: "STOP", value: "STOP" },
      // ],
      // filteredValue: filteredInfo.Status || null,
      // onFilter: (value, record) => record.Status === value,
      render: (text, record) => (
        <div className="justify-center flex items-center gap-2">
          <div>{text}</div>
        </div>
      ),
      ellipsis: true,
    },

    {
      title: "Reason",
      dataIndex: "Reason",
      key: "Reason",
      className: "whitespace-nowrap ",
      width: undefined
    },

    {
      title: "Comment",
      dataIndex: "Comment",
      key: "Comment",
      className: "whitespace-nowrap ",
      width: undefined
    },

  {
        title: (
          <Tooltip title="Add a comment to this user">
            <div>Add Comment</div>
          </Tooltip>
        ),
        key: "comment",
        className: "whitespace-nowrap",
        render: (record) => (
          <div>
            <button className="border-2 px-2 py-1" onClick={() => handleComment(record)}>
              Remark
            </button>
          </div>
        ),
      }
  ];

  const allColumns = [...columns];

  const handleSearch = () => {
    // setPage(1);
    ViewAPIs(size, page, filter, filter1, searchUsernames, statusFilter);
    ViewTotalApis(size, page, filter, filter1, searchUsernames, statusFilter);
  };

  const handleReasonChange = (value) => {
    setReason(value);
  };

  const filteredDataSource =
    Reason === "All"
      ? dataSource
      : dataSource.filter((item) => item.Reason === Reason);

  return (
    <>
      <div>
        <div className="p-2">
        <div className="flex flex-col  lg:flex-row justify-between gap-4 w-full  p-4 mb-4 items-center bg-white rounded-lg shadow-lg">
  {/* Search Section */}
  <div className="flex items-center w-full lg:w-auto">
    <Input
      placeholder="Search username"
      value={searchUsernames}
      onChange={(e) => setSearchUsernames(e.target.value.trim().toLowerCase())}
      className="lg:w-64 w-full"
    />
    <Button onClick={handleSearch} className="ml-2 w-full lg:w-auto mt-2 lg:mt-0">
      Search
    </Button>
  </div>

  {/* Filter Type Buttons */}
  <div className="flex gap-2 justify-center w-full lg:w-auto">
    {['ALL', 'LIVE', 'PAPER'].map((type) => (
      <button
        key={type}
        className={`mr-2 px-6 py-2 rounded-lg shadow-md w-full lg:w-auto ${filter === type
          ? 'bg-colorSecondaryDark text-white border-2 border-white'
          : 'bg-white text-colorSecondaryDark'}`}
        onClick={() => setFilter(type)}
      >
        {type}
      </button>
    ))}
  </div>

  {/* Filter Mode Buttons */}
  <div className="flex gap-2 justify-center w-full lg:w-auto">
    {["FUTURES", "SPOT"].map((type) => (
      <button
        key={type}
        className={`mr-2 px-6 py-2 rounded-lg shadow-md w-full lg:w-auto ${filter1 === type
          ? "bg-colorSecondaryDark text-white border-2 border-white"
          : "bg-white text-colorSecondaryDark"}`}
        onClick={() => setFilter1(type)}
      >
        {type}
      </button>
    ))}
  </div>

  {/* Status Dropdown */}
  <div className="flex items-center gap-2 w-full lg:w-auto">
    <label htmlFor="statusFilter" className="text-sm">Status:</label>
    <Select
      id="statusFilter"
      defaultValue="ALL"
      className="w-full lg:w-40"
      onChange={(value) => setStatusFilter(value)}
    >
      {["ALL", "ACTIVE", "INACTIVE", "PAUSED", "STOP"].map((status) => (
        <Option key={status} value={status}>
          {status}
        </Option>
      ))}
    </Select>
  </div>

  {/* Reason Dropdown */}
  <div className="flex items-center gap-2 w-full lg:w-auto">
    <label htmlFor="reasonFilter" className="text-sm">Reason:</label>
    <Select
      id="reasonFilter"
      defaultValue="All"
      className="w-full lg:w-40"
      onChange={handleReasonChange}
    >
      {["All", "Drawdown Hit", "Take Profit Hit"].map((status) => (
        <Option key={status} value={status}>
          {status}
        </Option>
      ))}
    </Select>
  </div>

  {/* Refresh Button */}
  <div className="flex items-center w-full lg:w-auto mt-4 lg:mt-0">
    {/* <Button onClick={fetchPrices} className="w-full lg:w-auto"> */}
      <HiOutlineRefresh />
      
    {/* </Button> */}
  </div>

  {/* Download CSV Button */}
  <div className="flex items-center w-full lg:w-auto mt-4 lg:mt-0">
    <Button type="colorSecondaryDark" className="ml-3 border-2 border-colorSecondaryDark my-2 md:my-0 w-full lg:w-auto">
      <CSVLink
        data={prepareDataForCSV()}
        filename={'user_data.csv'}
        className="text-white w-full lg:w-auto"
      >
        Download CSV
      </CSVLink>
    </Button>
  </div>
</div>


          <Table
            dataSource={filteredDataSource}
            columns={allColumns}
            pagination={false}
            // onChange={handleTableChange}
            onChange={handleChange}
            showSorterTooltip={false}

            scroll={{
              x: "auto",
            }}
          />
          <Pagination
            totalPages={totalPages}
            currentPage={page}
            pageSize={size}
            onPageChange={onPageChange}
            onPageSizeChange={handlePageSizeChange}
          />
<Modal
        title={`Add Comment for ${selectedUser}`}
        open={commentModal}
        // onOk={handleOk}
        onCancel={handleCancel}
        okText="Submit"
        cancelText="Cancel"
        footer={null}
      >
        <Input.TextArea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Enter your comment here..."
          rows={4}
        />
<div className="flex justify-end "> <button className="bg-blue-500 px-3 py-1 " onClick={handleOk}>Submit</button>
</div>
      </Modal>

        </div>
      </div>
    </>
  );
};

export default AllTrades;
